import {shift} from 'constants/url';
import useAdd from 'components/hooks/useAdd';
import {AddingOptions} from '../../../components/grid-dx/types';

function useAddTurn() {
  const addTurn = useAdd(shift);
  return (addingOptions: AddingOptions) => addTurn(addingOptions);
}

export default useAddTurn;
